import { webApi } from "../../../../core/http/httpThunks";
import { RevenueEstemateApiResponse } from "../types";

export const getSecurityRevenueEstimateApi = (userId: string, symbol: string, endpoint: string) => {
 // console.log("Poziva se getTradeApi sa:", { userId, divid });

  return webApi<RevenueEstemateApiResponse>({
    method: "GET",
    url: "reporting/getsecurityinfo",
    params: {
      userId,
      symbol,
      endpoint
    },
  });
};

export default getSecurityRevenueEstimateApi;
